import { defineComponent as v, useSlots as V, toRefs as $, ref as k, watch as f, onUpdated as B, onMounted as C, computed as E, openBlock as a, createElementBlock as c, normalizeClass as F, unref as s, createBlock as I, mergeProps as T, withCtx as i, createElementVNode as p, normalizeStyle as h, renderSlot as l, Fragment as N, createVNode as A } from "vue";
import { Tooltip as L } from "floating-vue";
import z from "../dialog-layout/dialog-layout.vue.js";
import { DIALOG_VARIANTS as H } from "../dialog-layout/dialog-layout-variants.js";
import { getFloatingVueOptions as R } from "./floating-vue-options.js";
import "floating-vue/dist/style.css";
import { ComponentSetupError as U } from "../../errors/component-setup-error.js";
import { ErrorLoggerInjectionFacade as W } from "../../injection/error-logger-injection-facade.js";
import { ScreenSize as j } from "../../user-agent/screensize.js";
const D = { class: "tooltip-target" }, M = v({
  name: "tooltip-layout"
}), Z = /* @__PURE__ */ v({
  ...M,
  props: {
    variant: { default: H._INFORMATION },
    maxWidth: {},
    interactiveHover: { type: Boolean, default: !0 },
    modelValue: { type: Boolean, default: !1 },
    title: { default: "Question Help" },
    useFullscreenTooltip: { type: Boolean, default: !0 }
  },
  emits: ["update:modelValue", "open", "close"],
  setup(y, { emit: r }) {
    const u = y, g = V(), S = new W().useInjection(), { modelValue: d } = $(u), t = k(d.value), w = new j().isSmallOrSmaller;
    f(d, (e) => {
      t.value = e;
    }), f(t, (e) => {
      r("update:modelValue", e), r(e ? "open" : "close");
    });
    const m = function() {
      g.content || S.logError(
        new U(
          "tooltip-layout",
          "no content was provided in the #content slot, or it became empty. Ensure you do not create empty tooltips!"
        )
      );
    };
    B(m), C(m);
    const O = E(() => ({ maxWidth: u.maxWidth + "px" }));
    return (e, o) => (a(), c("div", {
      class: F([e.$options.name])
    }, [
      !s(w) || !e.useFullscreenTooltip ? (a(), I(s(L), T({ key: 0 }, s(R)(e.$attrs, e.interactiveHover), {
        shown: t.value,
        "onUpdate:shown": o[0] || (o[0] = (n) => t.value = n)
      }), {
        popper: i(() => [
          p("div", {
            class: "popover-container",
            style: h(O.value)
          }, [
            l(e.$slots, "content", {}, void 0, !0)
          ], 4)
        ]),
        default: i(() => [
          p("span", D, [
            l(e.$slots, "default", {}, void 0, !0)
          ])
        ]),
        _: 3
      }, 16, ["shown"])) : (a(), c(N, { key: 1 }, [
        p("span", {
          class: "tooltip-target",
          onClick: o[1] || (o[1] = (n) => t.value = !0)
        }, [
          l(e.$slots, "default", {}, void 0, !0)
        ]),
        A(z, {
          "is-open": t.value,
          "onUpdate:isOpen": o[2] || (o[2] = (n) => t.value = n),
          variant: e.variant,
          title: e.title
        }, {
          default: i(() => [
            l(e.$slots, "content", {}, void 0, !0)
          ]),
          _: 3
        }, 8, ["is-open", "variant", "title"])
      ], 64))
    ], 2));
  }
});
export {
  Z as default
};
//# sourceMappingURL=tooltip-layout.vue2.js.map
